export const KHUSHI_COLORS = {
  maroon: "#2c0a12",
  maroonMid: "#4a1522",
  gold: "#d4af37",
  goldSoft: "#e8d5a3",
  ink: "#f8f0e6",
} as const;

export const KHUSHI_FONTS = {
  serif: '"Cormorant Garamond", "Times New Roman", serif',
  display: '"Cinzel", serif',
  script: '"Parisienne", "Allura", cursive',
  mono: '"DM Mono", ui-monospace, monospace',
} as const;

export const KHUSHI_FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Parisienne&family=DM+Mono:ital,wght@0,400;0,500;1,400&display=swap";

export function injectKhushiFonts(): void {
  if (typeof document === "undefined") return;
  if (!document.querySelector(`link[href="${KHUSHI_FONT_HREF}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = KHUSHI_FONT_HREF;
    document.head.appendChild(link);
  }
}

